<template>
  <div
    class="layout-topbar"
    :style="{ 'background-color': $BAR_BG_COLOR + ' !important' }"
  >
    <router-link to="/" class="layout-topbar-logo">
      <!-- <img alt="Logo" :src="darkTheme ? require(`@/assets/layout/images/wilmar-logo.png@`) : '@/assets/layout/images/wilmar-logo.png'" /> -->
      <img
        alt="Logo"
        :src="'/assets/layout/images/wilmar-logo.png'"
        style="mix-blend-mode: multiply"
      />
      <img
        alt="Logo"
        :src="'/assets/layout/images/weptw-2.png'"
        style="mix-blend-mode: multiply"
      />
      <!-- <span>{{ $APP_SHORT_NAME }}</span> -->
    </router-link>
    <button
      class="p-link layout-menu-button layout-topbar-button"
      @click="onMenuToggle"
      :style="{ color: $BAR_TEXT_COLOR + ' !important' }"
    >
      <i class="pi pi-bars"></i>
    </button>

    <button
      class="p-link layout-topbar-menu-button layout-topbar-button"
      v-styleclass="{
        selector: '@next',
        enterClass: 'hidden',
        enterActiveClass: 'scalein',
        leaveToClass: 'hidden',
        leaveActiveClass: 'fadeout',
        hideOnOutsideClick: true,
      }"
      :style="{ color: $BAR_TEXT_COLOR + ' !important' }"
    >
      <i class="pi pi-ellipsis-v"></i>
    </button>
    <ul class="layout-topbar-menu hidden lg:flex origin-top">
      <!-- <li>
				<button class="p-link layout-topbar-button" @click="readNotif">
					<i class="pi pi-bell p-text-secondary" v-badge="12"></i>
					<span>Notifications</span>
				</button>
			</li> -->
      <li>
        <div
          class="layout-topbar-button topbar-display-name"
          :style="{ color: $BAR_TEXT_COLOR + ' !important' }"
        >
          {{ this.displayTimezone }} [{{ this.displayTimezoneOffset }}]
          <Divider layout="vertical" />
        </div>
      </li>
      <li>
        <div
          class="layout-topbar-button topbar-display-name"
          :style="{ color: $BAR_TEXT_COLOR + ' !important' }"
        >
          {{ this.username }}
          <br />
          {{ this.displayName }}
          <Divider layout="vertical" />
        </div>
      </li>
      <li>
        <button
          class="p-link layout-topbar-button"
          @click="toggleChangelog"
          :style="{ color: $BAR_TEXT_COLOR + ' !important' }"
          label="Changelog"
          v-tooltip.bottom="'Changelog'"
        >
          <i class="pi pi-list"></i>
          <span style="display: none">Changelog</span>
        </button>
      </li>
      <li>
        <button
          class="p-link layout-topbar-button"
          @click="toggleCompanyCode"
          v-tooltip.bottom="'Workspace'"
        >
          <i
            class="pi pi-building p-text-secondary"
            v-badge="displayCompanyCode"
          ></i>
          <span>Company Code</span>

          <!-- <Menu ref="languageMenu" :model="languageItems" :popup="true" /> -->
        </button>
      </li>
      <li>
        <button
          class="p-link layout-topbar-button"
          @click="toggleLanguage"
          v-tooltip.bottom="'Language'"
        >
          <i class="pi pi-globe p-text-secondary" v-badge="badgeLang"></i>
          <span>Language</span>
          <Menu ref="languageMenu" :model="languageItems" :popup="true" />
        </button>
      </li>
      <li>
        <button
          class="p-link layout-topbar-button"
          @click="toggleStatus"
          v-tooltip.bottom="'Status'"
        >
          <i
            class="pi pi-user"
            v-badge="outOffice"
            :class="outOfficeFlag ? 'badge-red' : 'badge-green'"
          ></i>
          <span>Status</span>
          <Menu ref="statusMenu" :model="statusItems" :popup="true" />
        </button>
      </li>
      <li>
        <button
          class="p-link layout-topbar-button"
          @click="toggle"
          :style="{ color: $BAR_TEXT_COLOR + ' !important' }"
          v-tooltip.bottom="'Settings'"
        >
          <i class="pi pi-spin pi-cog"></i>
          <span style="display: none">Settings</span>
          <Menu ref="menu" :model="items" :popup="true" />
        </button>
      </li>
    </ul>
  </div>

  <ChangePassword
    v-if="changePassword"
    :isVisible="changePassword"
    :userId="username"
    :requireCurrentPassword="true"
    @hide="hideChangePasswordDialog"
    @block-ui="blockUI"
    @unblock-ui="unblockUI"
  />
  <ChangeProfile
    v-if="changeProfile"
    :isVisible="changeProfile"
    :userId="username"
    @hide="hideChangeProfile"
    @block-ui="blockUI"
    @unblock-ui="unblockUI"
  />
  <ChangeWorkSpace
    v-if="changeWorkSpace"
    :isVisible="changeWorkSpace"
    :userId="username"
    @hide="hideChangeWorkSpace"
    @block-ui="blockUI"
    @unblock-ui="unblockUI"
  />
</template>

<script>
export default {
  data() {
    return {
      username: this.$store.getters.getUsername,
      userId: this.$store.getters.getUserId,
      timezoneDescription: this.$store.getters.getTimezoneName,
      timezoneOffset: this.$store.getters.getTimezoneOffset,
      changePassword: false,
      changeProfile: false,
      changeWorkSpace: false,
      user: null,
    };
  },
  methods: {
    hideChangePasswordDialog(event) {
      this.changePassword = false;
      this.errormessage = "";

      if (event && event.success) {
        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: event.message,
          life: 3000,
        });
      }
    },
    hideChangeProfile(event) {
      this.changeProfile = false;
      this.$emit("toggle-changeprofile");
      this.errormessage = "";

      if (event && event.success) {
        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: event.message,
          life: 3000,
        });
      }
    },
    hideChangeWorkSpace(event) {
      this.changeWorkSpace = false;
      this.$emit("toggle-changeworkspace");
      this.errormessage = "";

      if (event && event.success) {
        this.$toast.add({
          severity: "success",
          summary: "Success",
          detail: event.message,
          life: 3000,
        });
      }
    },
    blockUI() {
      this.$emit("block-ui");
    },
    unblockUI() {
      this.$emit("unblock-ui");
    },
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    toggle(event) {
      this.$refs.menu.toggle(event);
    },
    toggleLanguage(event) {
      this.$refs.languageMenu.toggle(event);
    },
    toggleStatus(event) {
      this.$refs.statusMenu.toggle(event);
    },
    toggleCompanyCode(event) {
      //this.$refs.languageMenu.toggle(event);
    },
    logout() {
      //this.$emit('block-ui');

      // this.$axios.defaults.headers.common["Authorization"] = null;
      // this.$store.dispatch("logout");

      this.$router.push({ name: "Logout", params: { sessionExpired: "N" } });
    },
    changeStatus(event) {
      var self = this;
      this.blockUI();
      this.$axios
        .post(this.$API_URL + "util/change_status", {
          status: event,
          userId: this.userId,
        })
        .then((response) => {
          self.$store.dispatch("login", response.data.data);
          self.$axios.defaults.headers.common["Authorization"] =
            response.data.data.user_data.Token;
          self.$store.dispatch("isOutOffice", event);
          self.$emit("unblock-ui");
          self.$toast.add({
            severity: "success",
            summary: "Status Updated Successfully",
            detail: "You have changed the Status",
            life: 3000,
          });

          self.$nextTick(() => {
            window.location.reload();
          }); 
        })
        .catch(function (err) {
          //console.log(err);
          self.$emit("unblock-ui");
        });
    },
    changeLanguage(event) {
      var lang = event.item.id;
      var self = this;
      self.$emit("block-ui");
      self.blockUI();
      this.$axios
        .post(this.$API_URL + "util/change_language", {
          language: lang,
          userId: this.userId,
        })
        .then((response) => {
          self.$store.dispatch("login", response.data.data);
          self.$axios.defaults.headers.common["Authorization"] =
            response.data.data.user_data.Token;
          self.$root.$i18n.locale = lang;
          self.$axios.defaults.headers.common["language"] = lang;
          self.$store.dispatch("language", lang);
          self.$emit("unblock-ui");
          self.$toast.add({
            severity: "success",
            summary: "Language Updated Successfully",
            detail: "You have changed the language to " + lang,
            life: 3000,
          });
          // console.log(response);

          self.$nextTick(() => {
            window.location.reload();
          }); 
        })
        .catch(function (err) {
          //console.log(err);
          self.$emit("unblock-ui");
        });
    },
    readNotif() {
      //Send API to Flag all Read
    },
    toggleChangelog() {
      this.$emit("toggle-changelog");
    },
    toggleChangeProfile() {
      if (this.changeProfile) {
        this.$emit("toggle-changeprofile");
      }
    },
    toggleChangeWorkSpace() {
      if (this.changeWorkSpace) {
        this.$emit("toggle-changeworkspace");
      }
    },
  },
  computed: {
    darkTheme() {
      return this.$appState.theme.startsWith("saga");
    },
    lang() {
      return this.$store.getters.getLanguage;
    },
    outOffice() {
      var statusName = "";
      if (this.$store.getters.isOutOffice == false) {
        statusName = "ON";
      } else {
        statusName = "OFF";
      }

      return statusName;
    },
    outOfficeFlag() {
      return this.$store.getters.isOutOffice;
    },
    badgeLang() {
      return this.$store.getters.getLanguageUser.toUpperCase();
    },
    username() {
      return this.$store.getters.getUsername;
    },
    userId() {
      return this.$store.getters.getUserId;
    },
    displayName() {
      return this.$store.getters.getFullname;
    },
    displayCompanyCode() {
      return this.$store.getters.getCompanyCode;
    },
    displayTimezone() {
      return this.$store.getters.getTimezoneName;
    },
    displayTimezoneOffset() {
      return this.$store.getters.getTimezoneOffset;
    },
    languageItems() {
      var languages = this.$store.getters.getLanguages;

      var h = [];

      for (var i = 0; i < languages.length; i++) {
        var language = languages[i];
        h.push({
          label: language.text,
          icon: this.lang == language.id ? "pi pi-check" : "",
          command: (event) => {
            this.changeLanguage(event);
          },
          id: language.id,
        });
      }

      return h;
    },
    statusItems() {
      var statusItem = [
        {
          label: "ON",
          icon: this.$store.getters.isOutOffice == false ? "pi pi-check" : "",
          command: () => {
            this.changeStatus("N");
          },
        },
        {
          label: "OFF",
          icon: this.$store.getters.isOutOffice == true ? "pi pi-check" : "",
          command: () => {
            this.changeStatus("Y");
          },
        },
      ];
      return statusItem;
    },
    items() {
      var dataItems = [
        {
          label: "Change Profile",
          icon: "pi pi-fw pi-user",
          command: () => {
            this.changeProfile = true;
            this.toggleChangeProfile();
          },
        },
        {
          label: "Logout",
          icon: "pi pi-fw pi-power-off",
          command: () => {
            this.logout();
          },
        },
      ];

      if (this.$store.getters.getCompanyCode != "") {
        dataItems.unshift({
          label: "Change Workspace",
          icon: "pi pi-building",
          command: () => {
            this.changeWorkSpace = true;
            this.toggleChangeWorkSpace();
          },
        });
      }

      if (!this.$store.getters.getUseAD) {
        dataItems.unshift({
          label: "Change Password",
          icon: "pi pi-fw pi-lock",
          command: () => {
            this.changePassword = true;
          },
        });
      }

      return dataItems;
    },
  },
};
</script>

<style>
/* Define the styles for red and green badges */
.badge-red .p-badge {
  background-color: red !important;
  color: white !important;
}

.badge-green .p-badge {
  background-color: rgb(28, 201, 28) !important;
  color: white !important;
}
</style>
